export interface alertRule {
    element_id: number;
    report_id: number;
    segment_value_id: number;
    alert_rule_id?: number;
    user_id?: number;
    alert_rule_type: string;
    assign_type: string; //??useless
    send_alert_to_phone: string;
    customize_display_format_ind: string;
    customize_subject_format_ind: string;
    include_additional_message_ind: string;
    workflow_instance_id?: number;
    alert_type: string;
    alert_accessibility: string;
    alert_visibility: string;
    comparison_type: string;
    comparison_pct_tolerance: number;
    pct_comparison_type: string;
    comparison_fixed_value: number;
    comparison_fixed_value_2: number;
    compare_line_id: number;
    comparison_interval: string;
    comparison_interval_period: string;
    comparison_interval_compare_to: string;
    comparison_interval_compare_to_period: string;
    frequently_condition_satisfied: number;
    frequently_condition_values: number;
    trigger_alert_when_frequently: string;
    exclude_anomaly_points_ind: string;
    immediate_notification_ind: string;
    send_notification_via: string;
    trigger_alert_when: string;
    subject_format_email: string;
    subject_format_sms: string;
    display_format: string;
    visualization_type: string;
    visualization_element_id: number;
    visualization_segment_value_id?: number;
    match_measurement_time_ind: string;
    additional_message: string;
    email?: string;
    preview_for: string;
    workflow_id: string;
    workflow_priority_id: string;
    unusual_value_detection_method: string;
    target_id: number;
    user_defined_name: string;
    compound_selected_alert_rule: string[];
    comparison_type_fixed: string;
    alert_rule_count: number;
    alert_rule_count_type: string;
    range_of_values_scope: string;
}

export function AlertRulePrepareFormData(ruleData: alertRule, wizardData: alertRuleWizard) {
    const isNew = !ruleData.alert_rule_id;

    let alertRuleFormData: any = {
        ...ruleData,
        ...{
            segment_value_id: isNew && ruleData.segment_value_id > 0 ? -1 : ruleData.segment_value_id,
        },
    };

    delete alertRuleFormData.comparison_type_fixed; //static data

    if (alertRuleFormData.alert_type !== 'compound') {
        delete alertRuleFormData.compound_selected_alert_rule; //Compound
        delete alertRuleFormData.alert_rule_count; //Compound
        delete alertRuleFormData.alert_rule_count_type; //Compound
    }

    if (['average', 'volatility band'].includes(alertRuleFormData.alert_type)) {
        delete alertRuleFormData.compare_line_id; //All, except: average, volatility
    } else {
        delete alertRuleFormData.comparison_interval; //average, volatility
    }

    if (!['stoplight', 'volatility band'].includes(alertRuleFormData.alert_type)) {
        delete alertRuleFormData.range_of_values_scope; //Volatility, Stoplight
    }

    if (
        !['volatility band', 'compound', 'stoplight', 'unusual value', 'best ever', 'worst ever'].includes(
            alertRuleFormData.alert_type,
        )
    ) {
        delete alertRuleFormData.unusual_value_detection_method; //Volatility, Compound, Stoplight, unusual, best, worst
    }

    if (!(alertRuleFormData.alert_type == 'volatility band' && wizardData.isShowMovingRangeAlertCriteria)) {
        delete alertRuleFormData.unusual_value_detection_method; //, Volatility wizardData.isShowMovingRangeAlertCriteria
    }

    return alertRuleFormData;
}

function getCommonConstant(rawData: any) {
    const isNew = !rawData.alert_rule_id;

    const alertRuleType = rawData.global == 'Y' ? 'global' : rawData.form.data.alert_rule_type;
    const isKpi = rawData.global != 'Y' && (alertRuleType == 'user' || !alertRuleType); //($alertRuleType=='user'||empty($alertRuleType) = KPI
    const isGlobal = !isKpi; //$alertRuleType == global  || $alertRuleType = something else as Kpi

    return {
        isNew: isNew,
        isEdit: !isNew,
        alertRuleType: alertRuleType,
        isKpi: isKpi,
        isGlobal: isGlobal,
    };
}

const setDefaultFormValues = (dataObj: any, rawData: any, fieldsList?: string[]) => {
    const properties = fieldsList ?? Object.keys(dataObj);
    properties.forEach((key) => {
        if (!dataObj[key]) {
            //isEmpty value in current object

            //try to find same element at form data
            const formElSettings = rawData.form.settings.tabs[0].components.find(
                (formElement: any) => key == formElement.name,
            );

            //if find and it is select, then set first value from [] or {}
            if (formElSettings && formElSettings.component == 'FormSelect') {
                if (Array.isArray(formElSettings.data) && formElSettings.data.length) {
                    dataObj[key] = formElSettings.data[0].value;
                } else if (typeof formElSettings.data == 'object' && Object.keys(formElSettings.data).length) {
                    dataObj[key] = Object.keys(formElSettings.data)[0];
                }
            }
        }
    });

    return dataObj;
};

export function AlertRulePrepareData(rawData: any) {
    const { isNew, isEdit, alertRuleType, isKpi, isGlobal } = getCommonConstant(rawData);

    let alertData: alertRule = {
        //source_report //useless
        //workflow_proirities //useless
        element_id: rawData.element_id,
        report_id: rawData.report_id,
        visualization_element_id: rawData.visualization_element_id,
        user_id: rawData.user_id, //form + prop (maybe form ignore)
        segment_value_id: isNew && rawData.svId ? rawData.svId : rawData.segment_value_id, //++ form + prop
        alert_rule_id: rawData.form.data.alert_rule_id,
        alert_rule_type: alertRuleType, ///form!  alert_rule_type = rule_type (wizard)
        assign_type: rawData.form.data.assign_type ?? 'element', //set default: fix for new //form + prop: mi6 = element
        customize_display_format_ind: 'Y',
        customize_subject_format_ind: 'Y',
        include_additional_message_ind: 'Y',
        workflow_instance_id: rawData.form.data.workflow_instance_id,
        alert_type: isNew ? 'fixed value' : rawData.form.data.alert_type,
        alert_accessibility: isNew ? 'public' : rawData.form.data.alert_accessibility,
        alert_visibility: isGlobal ? 'public' : isNew ? 'public' : rawData.form.data.alert_visibility,
        comparison_type: rawData.form.data.comparison_type,
        comparison_pct_tolerance: isNew ? 10 : rawData.form.data.comparison_pct_tolerance,
        frequently_condition_values: isNew ? 1 : rawData.form.data.frequently_condition_values,
        frequently_condition_satisfied: isNew ? 1 : rawData.form.data.frequently_condition_satisfied,
        unusual_value_detection_method: isNew ? 'std' : rawData.form.data.unusual_value_detection_method,
        immediate_notification_ind: rawData.form.data.immediate_notification_ind,
        send_notification_via: rawData.form.data.send_notification_via,
        send_alert_to_phone: rawData.form.data.send_alert_to_phone,
        trigger_alert_when: rawData.form.data.trigger_alert_when,
        trigger_alert_when_frequently: rawData.form.data.trigger_alert_when_frequently,
        pct_comparison_type: rawData.form.data.pct_comparison_type,
        comparison_fixed_value: rawData.form.data.comparison_fixed_value ?? 0,
        comparison_fixed_value_2: rawData.form.data.comparison_fixed_value_2 ?? 0,
        compare_line_id: rawData.form.data.compare_line_id,
        comparison_interval: rawData.form.data.comparison_interval ?? 1, //check validate and move
        comparison_interval_period: rawData.form.data.comparison_interval_period,
        comparison_interval_compare_to: rawData.form.data.comparison_interval_compare_to,
        comparison_interval_compare_to_period: rawData.form.data.comparison_interval_compare_to_period,
        exclude_anomaly_points_ind: rawData.form.data.exclude_anomaly_points_ind,
        subject_format_email: rawData.form.data.subject_format_email,
        subject_format_sms: rawData.form.data.subject_format_sms,
        display_format: rawData.form.data.display_format,
        additional_message: rawData.form.data.additional_message,
        alert_rule_count: rawData.form.data.alert_rule_count,
        alert_rule_count_type: rawData.form.data.alert_rule_count_type,
        visualization_type:
            isNew && rawData.visualization_element_id != rawData.element_id
                ? 'other'
                : rawData.form.data.visualization_type,
        visualization_segment_value_id: rawData.form.data.visualization_segment_value_id,
        match_measurement_time_ind: rawData.form.data.match_measurement_time_ind,
        preview_for: 'email', //hardcode
        workflow_id: rawData.form.data.workflow_id ?? 0,
        workflow_priority_id: rawData.form.data.workflow_priority_id,
        target_id: rawData.form.data.target_id,
        user_defined_name: rawData.form.data.user_defined_name ?? '',
        range_of_values_scope: rawData.form.data.range_of_values_scope,
        email: '', //id="user_email"
        compound_selected_alert_rule: rawData.formCompoundAlertRulesSelected ?? [],
        comparison_type_fixed: '',
    };

    setDefaultFormValues(alertData, rawData);

    if (
        isKpi &&
        !['fixed value', 'prior value', 'average', 'target', 'volatility band', 'compound'].includes(
            alertData.alert_type,
        )
    ) {
        alertData.alert_type = 'fixed value';
    }

    if (isEdit && rawData.report_id > 0) {
        alertData.immediate_notification_ind = rawData?.reportSubscription?.immediate_notification_ind;
        alertData.send_notification_via = rawData?.reportSubscription?.send_notification_via;
        alertData.send_alert_to_phone = rawData?.reportSubscription?.send_alert_to_phone;
        alertData.trigger_alert_when = rawData?.reportSubscription?.trigger_alert_when;
    } else if (isNew && rawData.userPreferences) {
        alertData.immediate_notification_ind =
            rawData.userPreferences.immediate_notification_ind ?? alertData.immediate_notification_ind;
        alertData.send_notification_via =
            rawData.userPreferences.immediate_notification_via ?? alertData.send_notification_via;
        alertData.send_alert_to_phone = rawData.userPreferences.send_alert_to_phone ?? alertData.send_alert_to_phone;
        if (rawData.userPreferences.trigger_alert_when) {
            alertData.trigger_alert_when = rawData.userPreferences.trigger_alert_when;
            alertData.trigger_alert_when_frequently =
                rawData.userPreferences.trigger_alert_when === 'every time' ? 'every time' : 'first time only';
        }
    }

    //set value for workflow_priority_id
    if (!alertData.workflow_priority_id) {
        const selectedElement = (rawData?.workflow_priorities ?? []).find((item: any) => {
            return item.selected === 'Y';
        });

        if (selectedElement) {
            //From backend data
            alertData.workflow_priority_id = selectedElement.workflow_priority_id;
        } else {
            //Last elements
            let lastIndex = rawData?.workflow_priorities?.length;
            lastIndex = lastIndex > 0 ? lastIndex - 1 : '-1';
            alertData.workflow_priority_id =
                rawData?.workflow_priorities?.[lastIndex]?.workflow_priority_id ?? alertData.workflow_priority_id;
        }
    }

    //applayDefaultTemplates
    if (!alertData.subject_format_email && rawData.subjectTemplates?.email) {
        alertData.subject_format_email = rawData.subjectTemplates.email;
    }
    if (!alertData.subject_format_sms && rawData.subjectTemplates?.sms) {
        alertData.subject_format_sms = rawData.subjectTemplates.sms;
    }
    if (!alertData.display_format && rawData.alertTextTemplates) {
        let alert_type = alertData.alert_type;
        if (!rawData.alertTextTemplates.hasOwnProperty(alert_type)) {
            alert_type =
                alert_type == 'unusual value'
                    ? 'unusual'
                    : alert_type == 'worst ever'
                      ? 'low'
                      : alert_type == 'best ever'
                        ? 'high'
                        : 'other';
        }
        if (rawData.alertTextTemplates?.[alert_type]?.['N']) {
            alertData.display_format = rawData.alertTextTemplates[alert_type]['N'];
        }
    }

    //Ser default value for preview_for type
    alertData.preview_for =
        alertData.immediate_notification_ind == 'N'
            ? 'email'
            : alertData.immediate_notification_ind == 'Y'
              ? alertData.send_notification_via == 'phone_alert'
                  ? 'push'
                  : alertData.send_notification_via
              : 'email';

    return alertData;
}

export interface alertRuleWizard {
    form: any;
    isGlobal: boolean;
    isKpi: boolean;
    isNew: boolean;
    error: string[];
    step: number;
    indexStep: number;
    screens: screenSettings[];
    validationErrorField: {};
    priv_create_rule: boolean;
    priv_share_rule: boolean;
    priv_modif_rule: boolean;
    priv_set_notif_rule: boolean;
    priv_create_workflow: boolean;
    init_workflow_id: string;
    init_workflow_instance_id: number;
    issues_to_close: any;
    events_to_hide: number;
    dashboardElement?: any;
    alertSubscriptions: any[];
    formCompoundAlertRulesSelected: any[];
    userSendData: {
        email: string;
        push: string;
        sms: string;
    };
    isPhoneAlert: boolean;
    isSmsAlert: boolean;
    isShowWarningAlertRulePhone: boolean;
    simulation: any;
    simulationGrid: any[];
    alertTextTemplates: any;
    subjectTemplates: any;
    isShowMovingRangeAlertCriteria: boolean;
    simulationSegmentName: string;
    simulationTriggerDate: string;
    simulationTriggerCount: string;
    showAlertSimulationText: boolean;
}

interface screenSettings {
    key: screenType;
}

export type screenType = 'type' | 'criteria' | 'content' | 'workflow' | 'method';

export function getAlertRuleWizardInitialData() {
    let wizardData: alertRuleWizard = {
        form: {},
        isGlobal: false,
        isKpi: true,
        isNew: true,
        error: [],
        step: 1,
        indexStep: 0,
        screens: [],
        validationErrorField: {},
        priv_create_rule: false,
        priv_share_rule: false,
        priv_modif_rule: false,
        priv_set_notif_rule: false,
        priv_create_workflow: false,
        init_workflow_id: '',
        init_workflow_instance_id: 0,
        issues_to_close: undefined,
        events_to_hide: 0,
        dashboardElement: {},
        alertSubscriptions: [],
        formCompoundAlertRulesSelected: [],
        userSendData: {
            email: '',
            push: '',
            sms: '',
        },
        isPhoneAlert: false,
        isSmsAlert: false,
        isShowWarningAlertRulePhone: false,
        simulation: false,
        simulationGrid: [],
        alertTextTemplates: {},
        subjectTemplates: {},
        isShowMovingRangeAlertCriteria: false,
        simulationSegmentName: '',
        simulationTriggerDate: '',
        simulationTriggerCount: '',
        showAlertSimulationText: false,
    };
    return wizardData;
}

export function AlertRuleWizardPrepareData(rawData: any) {
    const { isNew, isKpi, isGlobal } = getCommonConstant(rawData);

    let wizardData: alertRuleWizard = {
        form: {},
        isGlobal: isGlobal,
        isKpi: isKpi,
        isNew: isNew,
        error: [],
        step: Number(rawData.step) ?? 1,
        indexStep: rawData.step - 1 >= 0 ? rawData.step - 1 : 0,
        screens: [],
        validationErrorField: {},
        priv_create_rule: rawData.priv_share_rule,
        priv_share_rule: rawData.priv_share_rule,
        priv_modif_rule: rawData.priv_modif_rule,
        priv_set_notif_rule: rawData.priv_set_notif_rule,
        priv_create_workflow: rawData.priv_create_workflow,
        init_workflow_id: rawData.form.data.workflow_id, //form prev_value
        init_workflow_instance_id: rawData.form.data.workflow_instance_id, //form prev_value
        issues_to_close: rawData.issues_to_close ?? 0,
        events_to_hide: rawData.events_to_hide ?? 0,
        alertSubscriptions: rawData.alertSubscriptions ?? [], //formAlertSubscriptions
        dashboardElement: rawData.element ?? {},
        userSendData: rawData.userSendData,
        isPhoneAlert: rawData.isPhoneAlert ?? false, //allowPhoneAlert
        formCompoundAlertRulesSelected: isNew ? [] : (rawData.formCompoundAlertRulesSelected ?? []),
        isSmsAlert: rawData.isSmsAlert ?? false, //allowSmsAlert
        isShowWarningAlertRulePhone: false, //id="warningAlertRulePhone" condition
        simulation: rawData.simulation,
        simulationGrid: rawData.simulationGrid,
        alertTextTemplates: rawData.alertTextTemplates,
        subjectTemplates: rawData.subjectTemplates,
        isShowMovingRangeAlertCriteria: rawData.isShowMovingRangeAlertCriteria ?? false,
        simulationSegmentName: '',
        simulationTriggerDate: '',
        simulationTriggerCount: '',
        showAlertSimulationText: false,
    };

    setDefaultFormValues(wizardData, rawData, ['init_workflow_id', 'init_workflow_instance_id']);

    if (isGlobal) {
        wizardData.screens = [{ key: 'type' }, { key: 'criteria' }, { key: 'method' }];
    } else {
        wizardData.screens = [{ key: 'type' }, { key: 'criteria' }, { key: 'content' } /*, { key: 'workflow' }*/];
    }

    //Form fields settings
    rawData.form.settings.tabs[0].components.forEach((formElement: any) => {
        wizardData.form[formElement.name] = formElement;
    });
    wizardData.form.workflow_priorities = { data: rawData.workflow_priorities ?? [] };

    wizardData.form.comparison_type_fixed = {
        data: {
            'more than a value': 'more than a value',
            'more than or equal to a value': 'more than or equal to a value',
            'less than a value': 'less than a value',
            'less than or equal to a value': 'less than or equal to a value',
            'not equal to a value': 'not equal to a value',
            'percentage of a value': 'percentage of a value',
            equal: 'equals a value',
        },
    };

    return wizardData;
}

export interface alertWorkflowInfo {
    statusGridData: any;
    roleGridData: any;
    workflow: any;
}

export function WorkflowInfoPrepareData(rawData: any) {
    let workflowInfo: alertWorkflowInfo = {
        statusGridData: (rawData.statusGrid ?? []).map((item: any) => {
            return { status: item.name, state: item.workflow_status_state };
        }),
        roleGridData: (rawData.roleGrid ?? []).map((item: any) => {
            return {
                role: item.name,
                create: item.initial_notification_type,
                update: item.update_notification_type,
            };
        }),
        workflow: rawData.workflow,
    };

    return workflowInfo;
}
